import { createContext } from "react";
import { DispatchDataResponse } from "react-acceptjs";

export interface IAuthorizeNetContext {
    existingCard?: any;
    setExistingCard: (value: any) => void;
    newPaymentDetails?: DispatchDataResponse;
    setNewPaymentDetails: (value: DispatchDataResponse) => void;
    isLoading: boolean;
    setIsLoading: (value: boolean) => void;
    nextSlide: () => void;
    prevSlide: () => void;
    processingCompleted: boolean;
    setProcessingCompleted: (value: boolean) => void;
}

export const AuthorizeNetContext = createContext<IAuthorizeNetContext>({});